export default "__VITE_ASSET__CcX49F06__"